import Req from '../../$axios'

const serviceModule = {
  // 获取树形结构/documentDrafts/read
  documentDraftsIndex(params) {
    return Req(
      {
        url: 'documentDrafts/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentSave(params) {
    return Req(
      {
        url: 'documentDrafts/save',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentUpdateSort(params) {
    return Req(
      {
        url: 'documentDrafts/updateSort',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentDelete(params) {
    return Req(
      {
        url: 'documentDrafts/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentRed(params) {
    return Req(
      {
        url: 'documentDrafts/read',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentDraftRecordsIndex(params) {
    return Req(
      {
        url: 'documentDraftRecords/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentDraftRecordsRead(params) {
    return Req(
      {
        url: 'documentDraftRecords/read',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 发布
  documentDraftUpdateReleaseStatus(params) {
    return Req(
      {
        url: 'documentDrafts/updateReleaseStatus',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentDraftUpdate(params) {
    return Req(
      {
        url: 'documentDrafts/update',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentIndex(params) {
    return Req(
      {
        url: 'documents/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentRead(params) {
    return Req(
      {
        url: 'documents/read',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentSuggestDoc(params) {
    return Req(
      {
        url: 'documents/suggestDoc',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentKeywordsIndex(params) {
    return Req(
      {
        url: 'documentKeywords/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  documentSearchDoc(params) {
    return Req(
      {
        url: 'documents/searchDoc',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取弹窗列表
  getNoticesList(params) {
    return Req(
      {
        url: 'popUpNotification/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取弹窗详情
  getNoticeDetail(params) {
    return Req(
      {
        url: 'popUpNotification/read',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 新增弹窗
  addNotice(params) {
    return Req(
      {
        url: 'popUpNotification/save',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新弹窗
  updateNotice(params) {
    return Req(
      {
        url: 'popUpNotification/update',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除弹窗
  delNotice(params) {
    return Req(
      {
        url: 'popUpNotification/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
}
